import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';

import styles from './Footer.css';
import FooterNav from './FooterNav/FooterNav';
import FooterLinks from './FooterLinks/FooterLinks';
import FooterContent from './FooterContent/FooterContent';
import shallowEqual from 'utils/shallowEqual';

export default class Footer extends Component {
	static contextTypes = {
		location: PropTypes.object.isRequired
	};
	shouldComponentUpdate(nextProps) {
		return !shallowEqual(this.props, nextProps);
	}

	componentDidCatch(error, info) {
		if (__DEBUG_ENV__) {
			console.error(info); // tslint:disable-line:no-console
			throw error;
		}
	}

	render() {
		const { otracker, showSummary, minimal, ...rest } = this.props;
		const isHomepage = this.context.location.pathname.match(/^\/$/);

		return (
			<footer className={cx(styles['footer'], { [styles['minimal']]: minimal })} {...rest}>
				<div className={styles['footer-content']}>
					{!isHomepage && showSummary && !minimal ? <FooterContent /> : null}
					<FooterLinks otracker={`${otracker}_footer`} />
					{isHomepage && showSummary ? <FooterContent /> : null}
					<FooterNav otracker={`${otracker}_footer`} minimal={minimal} />
				</div>
			</footer>
		);
	}
}
